// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as Home404RouteImport } from './routes/_home/404'
import { Route as HomeAboutRouteImport } from './routes/_home/about'
import { Route as HomeBlogRouteImport } from './routes/_home/blog'
import { Route as HomeContactRouteImport } from './routes/_home/contact'
import { Route as HomeCoursesRouteImport } from './routes/_home/courses'
import { Route as HomePlansRouteImport } from './routes/_home/plans'
import { Route as HomeSubscribeRouteImport } from './routes/_home/subscribe'
import { Route as HomeBlogIndexRouteImport } from './routes/_home/blog/index'
import { Route as HomeBlogBlogIdRouteImport } from './routes/_home/blog/$blogId'
import { Route as HomeCoursesIndexRouteImport } from './routes/_home/courses/index'
import { Route as HomeCoursesCourseIdRouteImport } from './routes/_home/courses/$courseId'

const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/_home',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => AuthRoute
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeRoute
          })
const Home404Route = Home404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => HomeRoute
          })
const HomeAboutRoute = HomeAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => HomeRoute
          })
const HomeBlogRoute = HomeBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => HomeRoute
          })
const HomeContactRoute = HomeContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => HomeRoute
          })
const HomeCoursesRoute = HomeCoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => HomeRoute
          })
const HomePlansRoute = HomePlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => HomeRoute
          })
const HomeSubscribeRoute = HomeSubscribeRouteImport.update({
            id: '/subscribe',path: '/subscribe',getParentRoute: () => HomeRoute
          })
const HomeBlogIndexRoute = HomeBlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeBlogRoute
          })
const HomeBlogBlogIdRoute = HomeBlogBlogIdRouteImport.update({
            id: '/$blogId',path: '/$blogId',getParentRoute: () => HomeBlogRoute
          })
const HomeCoursesIndexRoute = HomeCoursesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeCoursesRoute
          })
const HomeCoursesCourseIdRoute = HomeCoursesCourseIdRouteImport.update({
            id: '/$courseId',path: '/$courseId',getParentRoute: () => HomeCoursesRoute
          })





const AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,AuthSignupRoute: AuthSignupRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const HomeBlogRouteChildren = {
  HomeBlogBlogIdRoute: HomeBlogBlogIdRoute,HomeBlogIndexRoute: HomeBlogIndexRoute
}

const HomeBlogRouteWithChildren = HomeBlogRoute._addFileChildren(HomeBlogRouteChildren)




const HomeCoursesRouteChildren = {
  HomeCoursesCourseIdRoute: HomeCoursesCourseIdRoute,HomeCoursesIndexRoute: HomeCoursesIndexRoute
}

const HomeCoursesRouteWithChildren = HomeCoursesRoute._addFileChildren(HomeCoursesRouteChildren)



const HomeRouteChildren = {
  Home404Route: Home404Route,HomeAboutRoute: HomeAboutRoute,HomeBlogRoute: HomeBlogRouteWithChildren,HomeContactRoute: HomeContactRoute,HomeCoursesRoute: HomeCoursesRouteWithChildren,HomePlansRoute: HomePlansRoute,HomeSubscribeRoute: HomeSubscribeRoute,HomeIndexRoute: HomeIndexRoute
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,HomeRoute: HomeRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)